import React, { useEffect, useState } from 'react';
import { GetActiveSessionsOfAgentResponse } from '../../Model/Response/ClientAgent/GetActiveSessionsOfAgentResponse';
import { GetActiveSessionsOfAgent, GetChatSessionDetail } from '../../Controller/Api/ClientAgentController';
import { ApiBaseResponse, ResponseCode } from '../../Model/Response/Common/ApiBaseResponse';
import { useChat, AgentSideMessages, MessageSideEnum, SessionManagement } from './ChatContext';
import { GetChatSessionDetailResponse, MesajiGonderenTarafEnum, Message } from '../../Model/Response/ClientAgent/GetChatSessionDetailResponse';
import { GlobalOperations } from '../../Controller/Common/GlobalOperations';
import MessageInput from './MessageInput';  // MessageInput bileşeninden fonksiyonu kullanıyoruz
import { DisplayType, StatusEnum, useShowStatusMessage } from '../Components/CoreComponents/StatusMessage';

// SessionManagement modelini ekliyoruz 
const Sidebar: React.FC = () => {
    const { activeSessions, setMessages, setActiveSessions, setCurrentSession, typingUsers ,checkBeforeSwitchingSession} = useChat(); // ChatContext'ten ilgili fonksiyonlar ve state'leri çekiyoruz
    const [loading, setLoading] = useState<boolean>(false);

    // API'den aktif oturumları getirip set ediyoruz
    const fetchActiveSessions = async () => {
        setLoading(true);
        try {
            let response: ApiBaseResponse<GetActiveSessionsOfAgentResponse> | null =
                await GetActiveSessionsOfAgent();

            if (!response || !response.content || response.responseCode !== ResponseCode.OK) {
                console.error('API çağrısı başarısız: Aktif oturumlar alınamadı.');
                return;
            }

            // Gelen veriyi SessionManagement formatına çeviriyoruz
            const sessions: SessionManagement[] = response.content.sessions.map(session => ({
                sessionId: Number(session.sessionId),
                clientCompanyName: session.clientCompanyName || '',
                clientId: Number(session.clientId),
                serviceId: Number(session.serviceId),
                hasNewMessage: false, // Varsayılan olarak yeni mesaj yok
            }));
            setActiveSessions(sessions); // Aktif oturumları güncelliyoruz
        } catch (error) {
            console.error('API çağrısı başarısız:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchActiveSessions(); // Bileşen ilk yüklendiğinde aktif oturumları getiriyoruz
    }, []);

    // Mesajları AgentSideMessages modeline dönüştüren yardımcı fonksiyon
    const mapToClientAgentMessages = (message: Message): AgentSideMessages => {
        return {
            messageContent: message.messageContent,
            messageOwnerName: message.messageFrom,
            messageDateUtc: new Date(message.messageDate).getTime(),
            messageSide: message.side === MesajiGonderenTarafEnum.AlbinaSoft ? MessageSideEnum.Agent : MessageSideEnum.ClientUser,
        };
    };
    const showStatusMessage = useShowStatusMessage();
    // Oturum seçildiğinde detaylarını getirip mesajları güncelliyoruz
    const handleSessionClick = async (sessionId: number) => {


        // MessageInput'taki checkBeforeSwitchingSession fonksiyonunu çağırıyoruz
        let canSwitch: boolean =  checkBeforeSwitchingSession();  // True dönerse oturum değiştir
        if (!canSwitch) {
            showStatusMessage({
                header: 'Mesaj Alanında Metin Bulunuyor' ,
                text: 'Öncelikle Mesaj Alanında Bulunan Metni Gönderin veya Silin',
                status: StatusEnum.ERROR,
                direction: 'down',
                duration: 5000,
                displayType: DisplayType.TOP,
            });
            return;
        }

        console.log("Selected Session Id :" + sessionId);
        GlobalOperations.ActiveSessionId = sessionId;

        try {
            const response: ApiBaseResponse<GetChatSessionDetailResponse> | null =
                await GetChatSessionDetail(sessionId);

            if (!response || !response.content || response.responseCode !== ResponseCode.OK) {
                setCurrentSession(null); // Hata durumunda null set edelim
                return;
            }

            GlobalOperations.ClientId = response.content.clientId;
            GlobalOperations.ServiceId = response.content.serviceId;
            setCurrentSession(response.content);
            document.title = response.content.clientName;

            if (response.content?.messageList) {
                const mappedMessages = response.content.messageList.map(mapToClientAgentMessages);
                setMessages(mappedMessages); // Mesajları güncelliyoruz

                // Aktif oturumları güncelliyoruz, burada hasNewMessage'ı false yapıyoruz
                const updatedSessions = activeSessions.map((session: SessionManagement) =>
                    session.sessionId === sessionId
                        ? { ...session, hasNewMessage: false } // Eğer oturum id'leri eşleşiyorsa hasNewMessage'ı false yapıyoruz
                        : session
                );
                setActiveSessions(updatedSessions); // Güncellenmiş oturumları set ediyoruz

            }
        } catch (error) {
            console.error('Oturum detaylarını alma hatası:', error);
            setCurrentSession(null); // Hata durumunda oturum verisini sıfırlayalım
        }
    };

    return (
        <div
            className="sidebar"
            style={{
                width: '400px',
                padding: '20px',
                backgroundColor: '#2c3e50',
                height: '100vh',
                color: '#ecf0f1',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <div>
                <div
                    style={{
                        marginBottom: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#1abc9c',
                        color: '#fff',
                        padding: '15px',
                        borderRadius: '10px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <div
                        style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: '#16a085',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '10px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#ecf0f1',
                        }}
                    >
                        {GlobalOperations.UserName[0]?.toUpperCase()}
                    </div>
                    <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                        {GlobalOperations.UserName}
                    </div>
                </div>
                <hr style={{ borderColor: '#7f8c8d', margin: '0 0 20px 0' }} />
                <ul
                    style={{
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        maxHeight: 'calc(100vh - 180px)',
                        overflowY: 'auto',
                    }}
                >
                    {loading ? (
                        <li style={{ textAlign: 'center', color: '#ccc' }}>Yükleniyor...</li>
                    ) : activeSessions.length === 0 ? (
                        <li style={{ textAlign: 'center', color: '#ccc' }}>Aktif oturum yok</li>
                    ) : (
                        activeSessions.map((session) => (
                            <li
                                key={session.sessionId}
                                onClick={() => handleSessionClick(session.sessionId)}
                                style={{
                                    backgroundColor: GlobalOperations.ActiveSessionId === session.sessionId ? '#2980b9' : '#34495e',
                                    color: GlobalOperations.ActiveSessionId === session.sessionId ? '#fff' : '#ecf0f1',
                                    padding: '12px',
                                    marginBottom: '10px',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    boxShadow: GlobalOperations.ActiveSessionId === session.sessionId ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
                                }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                        <span>{session.clientCompanyName}</span>
                                        {session.hasNewMessage && (
                                            <span
                                                style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    backgroundColor: 'green',
                                                    borderRadius: '50%',
                                                    marginLeft: '5px', // Sola yerleştirmek için

                                                }}
                                            ></span>
                                        )}
                                    </div>
                                    {/* Kullanıcı yazıyorsa bunu göster */}
                                    {typingUsers[session.sessionId]?.length > 0 && (
                                        <div style={{ fontStyle: 'italic', color: '#bdc3c7', marginTop: '5px' }}>
                                            {typingUsers[session.sessionId].join(', ')} yazıyor...
                                        </div>
                                    )}
                                </div>

                            </li>
                        ))
                    )}
                </ul>
            </div>
            <div style={{ textAlign: 'center', fontSize: '12px', color: '#bdc3c7' }}>
                Albinasoft Chat Yönetim Sistemi
            </div>
        </div >
    );
};

export default Sidebar;
